import React from "react";
import "./Register.scss";
import { setItem } from "../../util/util";
import http from "../../util/api";
import {Toast, Icon,Picker,List } from "antd-mobile";
import qs from "qs";
import debounce from 'lodash/debounce';
import Loading from "../../components/Loading";

class Register extends React.Component {
  state = {
    countDown:0,
    showValue:false,
    charaV:'',
    chara: [{value:'患者',name:'患者'},{value:'专科医生',name:'专科医生'},{value:'营养师',name:'营养师'}],
    doctorV:'',
    doctor:[],
    checked:false,
    modalTitle:'选择角色',
    modalData:[],
    loading:true,
    searchValue:'',
    searchValue2:'',
    edit:0,
    illness:[],
    illnessV:'',
    memberName:'',
    hospital:[],
    hospitalV:'',
    imgUrl:'',
    REC_ID:'',
    phone:'',
    vCode:''
  }
  constructor(){
    super();
    this.getDoctor = debounce(this.getDoctor, 800);
    this.getHospital = debounce(this.getHospital, 800);
  }
  async componentDidMount() {
    let phoneNum=sessionStorage.getItem('phone');
   if(phoneNum){
     this.setState({phone:phoneNum});
   }
   let userName=sessionStorage.getItem('memberName');
   if(userName){
     this.setState({memberName:userName});
   }
   let charaV=sessionStorage.getItem('charaV');
   if(charaV){
     this.setState({charaV:{name:charaV,value:charaV}});
   }
   
   this.getData();
  }

  submit=async()=>{
   
    if(this.state.edit==1){
      let obj={
        REC_ID:this.state.REC_ID,
        doctorRecid:this.state.doctorV.value,
        doctorName:this.state.doctorV.nameOrg,
        illnessRecid:this.state.illnessV.value,
        hospitalRecid:this.state.doctorV.hospitalRecid||this.state.hospitalV.value,
        imgUrl:this.state.imgUrl,
        memberName:this.state.memberName,
        chara:this.state.charaV.value
      }
      this.setState({
        loading:true
      });
      try {
        const res = await http().modifyRecords({
          resid:685988118358,
          data:[obj]
        });
        this.setState({
          loading:false
        });
        Toast.success('成功',1);
        this.props.history.push('/user');
      } catch (error) {
        console.error(error);
        this.setState({loading:false});
        Toast.fail(error.message);
      }
    }else{
      if(!this.state.charaV.value){
        Toast.info('您还未填写用户角色');
        return false;
      }
      if(!this.state.phone){
        Toast.info('您还未填写手机号');
        return false;
      }
      if(this.state.phone.length!=11){
        Toast.info('手机号应该是11位');
        return false;
      }
      if(!this.state.vCode){
        Toast.info('您还未填写验证码');
        return false;
      }
      if(!this.state.checked){
        Toast.info('您还勾选隐私协议');
        return false;
      }
      if(!this.state.memberName){
        Toast.info('您还未填写用户名');
        return false;
      }
      this.setState({loading:true});
      this.regist().then(
        async(res)=>{
          if(res.ErrorMsg=='短信验证失败'){
            Toast.fail('验证码错误');
            this.setState({loading:false});
          }else{
            setItem("UserCode", res.UserCode);
            setItem("AccessToken", res.AccessToken);
            setItem("SysUserInfo", JSON.stringify(res.SysUserInfo));
            setItem("userInfo", JSON.stringify(res));
            if(res.AccessToken){
              try {
                const res2 = await http().addRecords({
                  resid:685988118358,
                  data:[{
                    phone:this.state.phone,
                    memberName:this.state.memberName,
                    chara:this.state.charaV.value
                  }]
                });
                console.log(res2)
                if(res2.data.Error==0){
                  this.props.history.push('/');
              sessionStorage.clear();

                }
              this.setState({loading:false});
  
              }catch(error){
                console.error(error);
                this.setState({loading:false});
                Toast.fail(error.message);
              }
            }
          }
          
        }
      )
    }
    
  }

  fileImgUp = async(v)=>{
   
    let files = v.target.files || v.dataTransfer.files;
    if (!files.length) return false;
    let type = files[0].name; 
    type=type.split('.')
    let size = files[0].size; //文件的大小，判断图片的大小
    if (size > 3670016) {
      Toast.info('请选择3.5M以内的图片！',1);
      return false;
    }
    this.setState({
      loading:true
    });
    this.uploadFile(
      files[0],
      `http://kingofdinner.realsun.me:1201/api/AliyunOss/PutOneImageObject?bucketname=nutritiontower&srctype=${
        type[1]
      }`,
      'cloud'
    ).then(
      result => {
        this.setState({imgUrl:result,loading:false})
      },
      err => {
        //图片上传异常！
        this.setState({ loading: false});
      }
    );
  }
  uploadFile = (file, url, mode) => {
    return new Promise((resolve, reject) => {
      let fd = new FormData();
      fd.append('file', file, file.name);
      const xhr = new XMLHttpRequest();
      xhr.open('POST', url);
      xhr.onload = () => {
        const data = JSON.parse(xhr.response);
        if (xhr.status === 200 && (data.error === 0 || data.error === '0')) {
          let imgUrl;
          if (mode === 'local') {
            imgUrl = data.httpfilename;
          } else if (mode === 'cloud') {
            imgUrl = data.data;
          }
          resolve(imgUrl);
        } else {
          reject(data);
        }
      };
      xhr.send(fd);
    });
  };
  sendPhoneNum=async()=>{
    return new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.open('GET', 'https://towerwx.realsun.me/rsauth/SendValidMsg?telephone='+this.state.phone);
      xhr.send(null);
    });
  }
  regist=async()=>{
    return new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      let obj={
        loginMethod:'mobile',
        useAccessToken:true,
        mobileno:this.state.phone,
        empid:this.state.phone,
        validcode:this.state.vCode
      }
      xhr.open('POST', 'https://tower.realsun.me/api/Account/Login');
      xhr.setRequestHeader('content-type', 'application/json');
      xhr.onload = () => {
        const data = JSON.parse(xhr.response);
        if (xhr.status === 200 && (data.error === 0 || data.error === '0')) {
          resolve(data);
        } else {
          reject(data);
        }
      };
      xhr.send(JSON.stringify(obj));
    });
  }

  countDown=async()=>{
    let _this=this;
    if(_this.state.phone){
      if(_this.state.phone.length!=11){
        Toast.info('手机号应该是11位');
      }else{
      let s = _this.state.countDown;
      if(s==0){
        s=10;
        let res=_this.sendPhoneNum();
      }
      _this.setState({countDown:10});
      let t = setInterval(()=>{
        s--;
        console.log(s)
        _this.setState({countDown:s});
        if(s==0){
          clearInterval(t);
        }
      },1000)
      }
    }else{
      Toast.fail('请先填写手机号',1)
    }
    
  }
  check=()=>{
    this.setState({checked:!this.state.checked});
  }
  openModal=(v)=>{
    if(v=='chara'){
      this.setState({modalTitle:'选择角色',modalData:this.state.chara,showValue:true});
    }else if(v=='doctor'){
      this.setState({modalTitle:'选择医生',modalData:this.state.doctor,showValue:true});
    }else if(v=='illness'){
      this.setState({modalTitle:'选择病种',modalData:this.state.illness,showValue:true});
    }else if(v=='hospital'){
      this.setState({modalTitle:'选择医院',modalData:this.state.hospital,showValue:true});
    }
  }
  selectValue=(v)=>{
    if(this.state.modalTitle=='选择角色'){
      sessionStorage.setItem('charaV',v.value);
      this.setState({charaV:v,doctorV:[],illnessV:[],hospital:[]});
    }else if(this.state.modalTitle=='选择医生'){
      this.setState({doctorV:v});
    }else if(this.state.modalTitle=='选择病种'){
      this.setState({illnessV:v});
    }else if(this.state.modalTitle=='选择医院'){
      this.setState({hospitalV:v});
    }
  }
  getData=async()=>{
    const search = document.location.search;
    const querystring = search.substring(1);
    const {agree} = qs.parse(querystring);
    const {edit} = qs.parse(querystring);
    if(agree=='1'){
      this.setState({checked:true});
    }
    if(edit=='1'){
      this.setState({edit:1});
    }
    this.setState({loading:true});
    try{
      // const res = await http().getTable({
      //   resid:686323553804
      // });
      let n =0;
      // let arr=[];
      // while(n<res.data.data.length){
      //   arr.push({
      //     value:res.data.data[n].chara,
      //     name:res.data.data[n].chara
      //   })
      //   n++;
      // }
      if(edit=='1'){
        const res2 = await http().getTable({
          resid:685108766308
        });
        const res3 = await http().getTable({
          resid:685988118358
        });
        if(res3.data.data.length>0){
          this.setState({
            charaV:{value:res3.data.data[0].chara,name:res3.data.data[0].chara},
            memberName:res3.data.data[0].memberName,
            doctorV:{value:res3.data.data[0].doctorRecid,name:res3.data.data[0].doctorName},
            illnessV:{value:res3.data.data[0].illnessRecid,name:res3.data.data[0].illness},
            hospitalV:{value:res3.data.data[0].hospitalRecid,name:res3.data.data[0].hospitalName},
            imgUrl:res3.data.data[0].imgUrl,
            REC_ID:res3.data.data[0].REC_ID
          })
        }else{
          Toast.fail('未能获取到用户信息',1);
          this.setState({loading:false});
          this.psops.history.push('/login')
        }
        let arr2=[];
        n=0;
        while(n<res2.data.data.length){
          arr2.push({
            name:res2.data.data[n].illness,
            value:res2.data.data[n].recid
          })
          n++;
        }
        this.setState({illness:arr2});
      }
      // this.setState({chara:arr});
      this.setState({loading:false});
    }catch (error) {
      console.error(error);
      this.setState({loading:false});
      Toast.fail(error.message);
    }
  }
  getDoctor=async(k)=>{
    if(k){
      this.setState({
        loading:true
      });
      try{
        const res = await http().getTable({
          resid:685105248585,
          key:k
        });
        let n =0;
        let arr=[];
        while(n<res.data.data.length){
          arr.push({
            value:res.data.data[n].recid,
            name:res.data.data[n].memberName+'-'+res.data.data[n].hospitalName,
            hospitalRecid:res.data.data[n].hospitalRecid,
            nameOrg:res.data.data[n].memberName
          })
          n++;
        }
        this.setState({loading:false,doctor:arr,modalData:arr});
      }catch (error) {
        console.error(error);
        this.setState({loading:false});
        Toast.fail(error.message);
      }
    }
  }

  getHospital=async(k)=>{
    if(k){
      this.setState({
        loading:true
      });
      try{
        const res = await http().getTable({
          resid:685108828680,
          key:k
        });
        let n =0;
        let arr=[];
        while(n<res.data.data.length){
          arr.push({
            value:res.data.data[n].recid,
            name:res.data.data[n].hospitalName
          })
          n++;
        }
        this.setState({loading:false,hospital:arr,modalData:arr});
      }catch (error) {
        console.error(error);
        this.setState({loading:false});
        Toast.fail(error.message);
      }
    }
  }
  render() {
    return (
      <div className="register">
        {this.state.loading?<Loading/>:null}
        <div className={this.state.showValue?'mask':'hidden'}>
          <div className='clz' onClick={
            ()=>{
              this.setState({
                showValue:false
              })
            }
          }>
          </div>
          <div className='modalContent'>
              <h3>{this.state.modalTitle} <Icon   onClick={()=>{
                this.setState({showValue:false});
              }} type='cross'style={{color:'#333',float:'right',verticalAlign:'middle',position:'absolute',top:'.5rem',right:'.5rem'}}/></h3>
              {this.state.modalTitle=='选择医生'?
              <input value={this.state.searchValue2} onChange={(v)=>{
                this.setState({searchValue2:v.target.value});
                this.getDoctor(v.target.value);
              }} placeholder='输入关键字查询'/>
              :null
              }
              {this.state.modalTitle=='选择医院'?
              <input value={this.state.searchValue} onChange={(v)=>{
                this.setState({searchValue:v.target.value});
                this.getHospital(v.target.value);
              }} placeholder='输入关键字查询'/>
              :null
              }
              <ul>
                {
                  this.state.modalData.map(
                    (item,key)=>{
                      return(
                        <li key={key} onClick={()=>{this.selectValue(item)}} 
                        className=
                      {this.state.modalTitle=='选择角色'?(this.state.charaV.value==item.value?'current':''):
                        (this.state.modalTitle=='选择医生'?(this.state.doctorV.value==item.value?'current':''):
                          (this.state.modalTitle=='选择病种'?(this.state.illnessV.value==item.value?'current':''):
                            (this.state.hospitalV.value==item.value?'current':'')))}>{item.name}</li>
                      )
                    }
                  )
                }
              </ul>
          </div>
          
          <div className='mainBtn'
            onClick={
              ()=>{
                this.setState({showValue:false})
              }
            }
          >
            确定
          </div>
        </div>
       {/* <div className='header'>
         <div className='logo'
         onClick={()=>{
           if(this.state.edit=='1'){
            this.props.history.push('/')
           }
         }}
         >主页</div>
        </div> */}
        <div className='container'>
              <h3>{this.state.edit==0?'用户注册':'修改信息'}</h3>
              <div className='form'>
                
              <div>
                  <label>姓名：</label><input value={this.state.memberName} onChange={(v)=>{
                    this.setState({
                      memberName:v.target.value
                    });
                    sessionStorage.setItem('memberName',v.target.value);
                  }}/>
                </div>
                {
                  this.state.edit=='0'?
                  <>
                  <div>
                    <label>手机号：</label><input value={this.state.phone} onChange={(v)=>{
                    this.setState({
                      phone:v.target.value
                    })
                  }}/>
                  </div>
                  <div className='verti'>
                    <label>验证码：</label>
                    <input maxLength={4} value={this.state.vCode} onChange={(v)=>{this.setState({vCode:v.target.value})}}/><div className={this.state.countDown==0?'btn':'btn disabled'} onClick={()=>{this.countDown();}}>{this.state.countDown==0?'发送验证码':this.state.countDown+'秒后重试'}</div>
                   </div>
                   
                <div>
                  <label>用户角色：</label><b onClick={()=>{this.openModal('chara')}} style={this.state.charaV?{}:{color:'#999'}}>{this.state.charaV?this.state.charaV.name:'点击选择角色'}<Icon type='down' style={{color:'#333',float:'right',verticalAlign:'middle'}}/></b>
                </div>
                   </>
                  :null
                }
                {
                  this.state.charaV.value=='患者'&&this.state.edit=='1'?
                  <div>
                  <label>医生：</label><b onClick={()=>{this.openModal('doctor')}} style={this.state.doctorV?{}:{color:'#999'}}>{this.state.doctorV?this.state.doctorV.name:'点击选择医生'}<Icon type='down' style={{color:'#333',float:'right',verticalAlign:'middle'}}/></b>
                </div>:null
                }
                 {
                  this.state.charaV.value=='医生'&&this.state.edit=='1'?
                  <div>
                  <label>医院：</label><b onClick={()=>{this.openModal('hospital')}} style={this.state.hospitalV?{}:{color:'#999'}}>{this.state.hospitalV?this.state.hospitalV.name:'点击选择医院'}<Icon type='down' style={{color:'#333',float:'right',verticalAlign:'middle'}}/></b>
                </div>:null
                }
                {
                  this.state.edit=='0'?
                <div>
                  <p><circle className={this.state.checked?'checked':''} onClick={()=>{this.check();}}></circle> 我已阅读并同意<span onClick={()=>{this.props.history.push('/agreement?returnroute=register')}}>《隐私协定》</span></p>
                </div>
                :
                <>
                  <div>
                    <label>病种：</label><b onClick={()=>{this.openModal('illness')}} style={this.state.illnessV?{}:{color:'#999'}}>{this.state.illnessV?this.state.illnessV.name:'点击选择病种'}<Icon type='down' style={{color:'#333',float:'right',verticalAlign:'middle'}}/></b>
                  </div>
                </>
                }
                {
                  this.state.edit=='1'?
                  <div className='avatarUp'>
                    <label>头像图片：</label>
                   
                    <input
                   id="ss"
                   name="ss"
                   type="file"
                   onChange={v => {
                     this.fileImgUp(v);
                   }}
                   accept="image"
                   style={{display:'none'}}
                 />
                      <div
                      onClick={
                        ()=>{
                          document.getElementById("ss").click();
                        }
                      }
                        style={{
                          backgroundImage:'url('+this.state.imgUrl+')',
                          backgroundSize:'contain',
                          backgroundRepeat:'no-repeat',
                          backgroundPosition:'center'
                        }}
                      >
                        {this.state.imgUrl?null:'点击选择图片'}
                      </div>
                  </div>
                  
                  :null
                }
              </div>
        </div>
        
        <div className='mainBtn' onClick={()=>{
                      this.submit();
                  }}>
         {this.state.edit==0?'注册':'确认'} 
        </div>
      </div>
    );
  }
}

export default Register;
